import { Component } from '@angular/core';
import { BeneficiaryAccountProperties, GetAllocatedAccountsProperties } from '../Models/BeneficiaryAccountProperties';
import { BeneficiaryService } from '../Services/beneficiary.service';

@Component({
    selector: 'app-beneficary-details-list',
    templateUrl: './beneficary-details-list.component.html',
    styleUrls: ['./beneficary-details-list.component.css']
})
/** BeneficaryDetailsList component*/
export class BeneficaryDetailsListComponent {
  vari: string ="";
    /** BeneficaryDetailsList ctor */
  constructor(private beneficiaryService: BeneficiaryService) {

  }
 
  beneficiaryAllocationData: GetAllocatedAccountsProperties[] = [];
  ngOnInit() {
    this.getBeneficiaryAllocationData(localStorage.getItem("AgencyId"));
  }
  getBeneficiaryAllocationData(value: string) {
    try {
      // 
      this.beneficiaryService.getBeneficiaryAccAllocation(value).subscribe((data) => {
        this.beneficiaryAllocationData = data;
      });
    }
    catch (e) { }
  }

}
